export class SparkConnectCredentialsAirflowConnection {
    static discriminator = undefined;
    static attributeTypeMap = [
        {
            "name": "connType",
            "baseName": "connType",
            "type": "SparkConnectCredentialsAirflowConnectionConnTypeEnum",
            "format": ""
        },
        {
            "name": "host",
            "baseName": "host",
            "type": "string",
            "format": ""
        },
        {
            "name": "port",
            "baseName": "port",
            "type": "number",
            "format": ""
        },
        {
            "name": "password",
            "baseName": "password",
            "type": "string",
            "format": ""
        },
        {
            "name": "extra",
            "baseName": "extra",
            "type": "SparkConnectCredentialsAirflowConnectionExtra",
            "format": ""
        }
    ];
    static getAttributeTypeMap() {
        return SparkConnectCredentialsAirflowConnection.attributeTypeMap;
    }
    constructor() {
    }
}
export var SparkConnectCredentialsAirflowConnectionConnTypeEnum;
(function (SparkConnectCredentialsAirflowConnectionConnTypeEnum) {
    SparkConnectCredentialsAirflowConnectionConnTypeEnum["SparkConnect"] = "spark_connect";
})(SparkConnectCredentialsAirflowConnectionConnTypeEnum || (SparkConnectCredentialsAirflowConnectionConnTypeEnum = {}));
